"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = pm;
var _index = _interopRequireDefault(require("../3rdparty/bbcode/index"));
var _BobTVUser = require("../components/BobTVUser");
var _pm = require("../types/pm");
var _pm2 = require("../constants/pm");
var _notifications = require("../constants/notifications");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function firstUnreadMessageTimestamp(messages) {
  if (messages.length == 0) return 0;
  var timestamp = messages[0].timestamp + 1;
  var _iterator = _createForOfIteratorHelper(messages),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var msg = _step.value;
      if (msg.read_status == _pm.ReadStatus.UNREAD && msg.timestamp < timestamp) {
        timestamp = msg.timestamp;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return timestamp;
}
function isHistoryDeleted(conv) {
  var res = true;
  if (conv.messages.length != 1) {
    res = false;
  } else if (conv.messages[0].payload.type != "notification") {
    res = false;
  } else if (conv.messages[0].payload.data.type != "history_deleted") {
    res = false;
  } else {
    conv.historyDeleted = {
      status: true,
      initiatorNick: conv.messages[0].sender_nick
    };
  }
  return res;
}
function newConversation(args, in_recipient) {
  var recipient = in_recipient ? in_recipient : args.users.recipient;
  //if (!recipient) recipient = args.users.recipient;

  var access = args.access ? args.access : _pm2.PM_ACCESS_ALLOW;
  var hidden = args.view ? args.view.hidden : true;
  var unread = args.unread ? args.unread : false;
  var online = recipient.online;
  var blocked = false;
  var unreadCount = 0;
  var history = args.history ? args.history : {
    unread: unread,
    messages: [],
    can_move_backward: false
  };
  if (unread) hidden = false;
  if (access == "negotiating") {
    hidden = false;
    unreadCount = "?";
  }
  switch (access) {
    case _pm2.PM_ACCESS_DENY:
      blocked = true;
      break;
  }
  var defaultConversation = {
    user: recipient,
    // Recipient BobTVUser object
    online: recipient.online,
    // Is recipient online?
    active: !hidden,
    blocked: blocked,
    outgoing: false,
    // Who initiated conversation, used for negotiating process display
    unread: unread,
    // Has unread messages
    unreadCount: 0,
    access: access,
    // PM_ACCESS_ALLOW | PM_ACCESS_DENY | PM_ACCESS_UNKNOWN
    messages: [],
    // Current slice of messages
    attachments: [],
    created: args.created ? args.created : 0,
    modified: args.modified ? args.modified : 0,
    // Last conversation update time, for sorting
    minimizedTimestamp: 0,
    // ???
    historyDeleted: {
      status: false,
      initiatorNick: ''
    },
    history: history,
    view: {
      maximized: false,
      hidden: hidden
    },
    fetchedHistory: false,
    status: args.status,
    generalStatus: getGeneralStatus(args, recipient.uid, null)
  };
  var conversation = _objectSpread(_objectSpread(_objectSpread({}, defaultConversation), args), {}, {
    messages: []
  });
  if (args.messages) {
    var messages = [];
    for (var i = 0; i < args.messages.length; i++) {
      messages[i] = messageFromRec(args.messages[i]);
    }
    conversation = addMessagesToSession(conversation, args.messages);
    conversation.minimizedTimestamp = firstUnreadMessageTimestamp(messages);
    // conversation.unreadCount = calculateUnreadCount(conversation.messages);
  }
  if (access === _pm2.PM_ACCESS_DENY) {
    if (args.denied_by != recipient.uid) {
      conversation.access = _pm2.PM_ACCESS_DENIED_BY_ME;
    }
    conversation.view.hidden = true;
  }
  if (isHistoryDeleted(conversation)) {
    conversation.view.hidden = true;
    conversation.unread = false;
    conversation.historyDeleted = {
      status: true,
      initiatorNick: conversation.messages[0].sender_nick
    };
    // conversation.blocked = true;
  }
  return conversation;
}
function calculateUnreadCount(messages) {
  var res = 0;
  for (var i = 0; i < messages.length; i++) {
    if (messages[i].read_status == 0) res++;
  }
  return res;
}
function updateStateConversationUncurried(state, uid, conversation) {
  var newState = _objectSpread({}, state);
  newState[uid] = conversation;
  return newState;
}
function updateStateConversationCurried(state) {
  return function (conversation) {
    return updateStateConversationUncurried(state, conversation.user.uid, conversation);
  };
}
function minimizeAll(state) {
  var newState = {};
  for (var index in state) {
    if (state[index].view.maximized == false) {
      newState[index] = state[index];
    } else {
      newState[index] = _objectSpread(_objectSpread({}, state[index]), {}, {
        view: _objectSpread(_objectSpread({}, state[index].view), {}, {
          maximized: false
        })
      });
    }
  }
  return newState;
}
function deletePmSession(state, sessionuid) {
  var ret = _objectSpread({}, state);
  delete ret[sessionuid];
  return ret;
}
function renderMessage(m) {
  if (m.payload.type == "message") {
    return (0, _index["default"])(m.payload.text, {
      extractAttachments: true
    });
  }
}
function fetchAttachments(messages, conv) {
  var result = [];
  var _iterator2 = _createForOfIteratorHelper(messages),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var m = _step2.value;
      if (!m.rendered) continue;
      if (m.rendered.attachments) {
        var _iterator3 = _createForOfIteratorHelper(m.rendered.attachments),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var a = _step3.value;
            var attachment = _objectSpread(_objectSpread({}, a), {}, {
              timestamp: m.timestamp,
              text: m.rendered.text,
              author_uid: m.sender_uid,
              author_label: m.sender_uid == conv.user.uid ? "recipient" : "me"
            });
            result.push(attachment);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return result;
}
function addMessagesToSession(session, extMessages) {
  var messages = [];
  for (var i = 0; i < extMessages.length; i++) {
    messages[i] = messageFromRec(extMessages[i]);
  }
  if (messages.length === 0) return session;
  var newMessages = messages;

  //if (!isEmpty(session.messages)) {
  var _loop = function _loop(_i) {
    newMessages = newMessages.filter(function (a) {
      return a.mid !== session.messages[_i].mid;
    });
  };
  for (var _i = 0; _i < session.messages.length; _i++) {
    _loop(_i);
  }
  //}

  var renderedMessages = newMessages.map(function (m) {
    return _objectSpread(_objectSpread({}, m), {}, {
      rendered: renderMessage(m)
    });
  });
  var combinedMessages = [].concat(_toConsumableArray(session.messages), _toConsumableArray(renderedMessages)).sort(function (a, b) {
    return a.id - b.id;
  });
  var newAttachments = fetchAttachments(renderedMessages, session);
  var combinedAttachments = [].concat(_toConsumableArray(session.attachments), _toConsumableArray(newAttachments)).sort(function (a, b) {
    return a.timestamp - b.timestamp;
  });
  var modifiedDate = Math.max(session.modified, getLastMessageDate(messages));
  if (session.view.maximized) {
    for (var _i2 in combinedMessages) {
      combinedMessages[_i2].read_status = 1;
    }
  }
  var newSession = _objectSpread(_objectSpread({}, session), {}, {
    modified: modifiedDate,
    notification: null,
    messages: combinedMessages,
    attachments: combinedAttachments,
    history: _objectSpread(_objectSpread({}, session.history), {}, {
      messages: combinedMessages
    }),
    unreadCount: calculateUnreadCount(combinedMessages)
  });
  if (!isHistoryDeleted(newSession)) {
    newSession.historyDeleted = {
      status: false,
      initiatorNick: ''
    };
  }
  return newSession;
}
function markAsUnread(conversation) {
  var unread = true;
  if (conversation.view.maximized) unread = false;
  return _objectSpread(_objectSpread({}, conversation), {}, {
    unread: unread,
    view: _objectSpread(_objectSpread({}, conversation.view), {}, {
      hidden: false
    }),
    blocked: false
  });
}
function markAsRead(conversation) {
  var unread = false;
  var messages = conversation.messages;
  for (var i in messages) {
    messages[i].read_status = 1;
  }
  return _objectSpread(_objectSpread({}, conversation), {}, {
    unread: unread,
    messages: messages,
    view: _objectSpread(_objectSpread({}, conversation.view), {}, {
      hidden: false
    }),
    blocked: false
  });
}
function getGeneralStatus(conversation, recipient_uid, localConversation) {
  var users = localConversation ? localConversation.users : conversation.users;
  if (conversation.users) users = conversation.users;
  var currentUser = users.me;
  var block_type = (0, _BobTVUser.isBeingBlocked)(currentUser, users.recipient);
  if (block_type) {
    return 'blocked_by_recipient';
  }
  if ((0, _BobTVUser.isUserBlocked)(currentUser, users.recipient)) {
    return 'blocked_by_me';
  }
  var generalStatus = 'allowed';
  switch (conversation.status.status) {
    case 'allow':
      generalStatus = 'allowed';
      break;
    case 'requested':
      if (conversation.status.user == recipient_uid) {
        generalStatus = 'requested_by_recipient';
      } else {
        generalStatus = 'requested_by_me';
      }
      break;
    case 'deny':
      if (conversation.status.users[0] == recipient_uid && conversation.status.users.length == 1) {
        generalStatus = 'denied_by_recipient';
      } else {
        generalStatus = 'denied_by_me';
      }
      break;
    default:
      generalStatus = 'cancelled';
  }
  return generalStatus;
}
function updateUser(localConversation, user) {
  var generalStatus = localConversation.generalStatus;
  return _objectSpread(_objectSpread({}, localConversation), {}, {
    users: _objectSpread(_objectSpread({}, localConversation.users), {}, {
      recipient: user
    }),
    user: user
  });
}
function updateConversation(localConversation, remoteConversation) {
  var generalStatus = getGeneralStatus(remoteConversation, localConversation.user.uid, localConversation);
  if (generalStatus == "cancelled") return "delete";
  var view = localConversation.view;
  var blocked = localConversation.blocked;
  var newUser = localConversation.user;
  var users = localConversation.users;
  if (remoteConversation.users) {
    newUser = remoteConversation.users.recipient;
    users = remoteConversation.users;
  }
  return _objectSpread(_objectSpread({}, localConversation), {}, {
    user: newUser,
    users: users,
    view: view,
    blocked: blocked,
    status: remoteConversation.status,
    generalStatus: generalStatus
  });
}
function activateConversation(conversation) {
  conversation = markAsRead(conversation);
  return _objectSpread(_objectSpread({}, conversation), {}, {
    view: _objectSpread(_objectSpread({}, conversation.view), {}, {
      hidden: false,
      maximized: true
    }),
    blocked: false
  });
}
function hideConversation(conversation) {
  return _objectSpread(_objectSpread({}, conversation), {}, {
    view: _objectSpread(_objectSpread({}, conversation.view), {}, {
      hidden: true,
      maximized: false
    }),
    unread: false,
    unreadCount: 0
  });
}
function addTypingNotification(session, action) {
  return _objectSpread(_objectSpread({}, session), {}, {
    notification: action.notification
  });
}
function removeTypingNotification(session) {
  return _objectSpread(_objectSpread({}, session), {}, {
    notification: null
  });
}

/*
function addNotificationToSession(session : Conversation, action: ConversationActionPrivateTokenNotification) : Conversation {
    let notification: PmPrivateTokenNotification = {
        type: "private_token",
        amount: action.data.amount
    }
    let message: Message = {
        sender_uid: session.users.
        payload: {
            type: "notification",
            data: notification
        }
    }
    return {
        ...session,
        messages: [...session.messages, message]
    };
}
*/

function deleteHistory(session, action) {
  var newSession = _objectSpread({}, session);
  var sender_uid = 0;
  var sender_nick = "";
  var recipient_uid = 0;
  var recipient_nick = "";
  if (session.user.uid == action.deleteHistory.initiator) {
    sender_uid = session.user.uid;
    sender_nick = session.user.nick;
    recipient_uid = 0;
    recipient_nick = "";
  } else {
    sender_uid = action.deleteHistory.initiator;
    sender_nick = action.deleteHistory.initiator_nick;
    recipient_uid = session.user.uid;
    recipient_nick = session.user.nick;
    newSession.view = {
      active_attachment: false,
      hidden: true,
      maximized: false
    };
    //newSession.blocked = true;
  }
  var msgHd = {
    id: 1,
    mid: "history_deleted",
    sender_uid: sender_uid,
    sender_nick: sender_nick,
    recipient_uid: recipient_uid,
    recipient_nick: recipient_nick,
    timestamp: 0,
    read_status: _pm.ReadStatus.UNREAD,
    payload: {
      type: "notification",
      data: {
        type: "history_deleted"
      }
    }
  };
  return _objectSpread(_objectSpread({}, newSession), {}, {
    messages: [msgHd],
    historyDeleted: {
      status: true,
      initiatorNick: action.deleteHistory.initiator_nick
    }
  });
}
function getLastMessageDate(messages) {
  var lastTimestamp = 0;
  for (var i = 0; i < messages.length; i++) {
    if (messages[i].timestamp > lastTimestamp) lastTimestamp = messages[i].timestamp;
  }
  return lastTimestamp;
}
function messageFromRec(message) {
  var oldMsg = message;
  var newMsg = message;
  if (newMsg.payload) {
    return newMsg;
  }
  return messageFromOldRec(oldMsg);
}
function messageFromOldRec(messageRec) {
  var result = {
    id: messageRec.id,
    mid: messageRec.mid,
    sender_uid: messageRec.sender_uid,
    sender_nick: messageRec.sender_nick,
    recipient_uid: messageRec.receiver_uid,
    recipient_nick: messageRec.receiver_nick,
    timestamp: messageRec.timestamp,
    read_status: messageRec.read_status,
    payload: {
      type: "message",
      text: messageRec.message
    }
  };
  return result;
}
function pmConversationReducer(conv, action) {
  if (action.type === _pm2.PM_USER_UPDATE) {
    return updateUser(conv, action.user);
  }
  if (action.type === _pm2.PM_CONVERSATION_CHANGED) {
    return updateConversation(conv, action.data.conversation);
  }
  if (action.type === _notifications.PRIVATE_TOKEN_NOTIFICATION) {
    // return addNotificationToSession(conv, action);
  }
  if (action.type === _pm2.PM_TYPING_NOTIFY) {
    return addTypingNotification(conv, action);
  }
  if (action.type === _pm2.PM_CLEAR_TYPING_NOTIFY) {
    return removeTypingNotification(conv);
  }
  if (action.type === _pm2.PM_DELETE_HISTORY) {
    return deleteHistory(conv, action);
  }
  if (action.type === _pm2.PM_SESSION_HIDE) {
    return hideConversation(conv);
  }
  if (action.type === "PM_ACTION_VIDEO_CALL_START") {
    return _objectSpread(_objectSpread({}, conv), {}, {
      videoCall: {
        call_id: 'undefined',
        conversation_uid: action.conversation_uid,
        state: 'new',
        data: {},
        incoming: false,
        mic: true,
        local_connection: true
      }
    });
  }
  if (action.type === "PM_ACTION_VIDEO_CALL_START_ERROR") {
    return _objectSpread(_objectSpread({}, conv), {}, {
      videoCall: {
        call_id: 'undefined',
        conversation_uid: action.conversation_uid,
        state: 'ended',
        ended_reason: action.reason,
        data: {},
        incoming: false,
        mic: true,
        local_connection: true
      }
    });
  }
  if (action.type === "PM_ACTION_VIDEO_CALL_ANSWER") {
    if (!conv.videoCall) return conv;
    return _objectSpread(_objectSpread({}, conv), {}, {
      videoCall: _objectSpread(_objectSpread({}, conv.videoCall), {}, {
        local_connection: true,
        mic: true
      })
    });
  }
  if (action.type === "PM_VIDEO_CALL_INFO") {
    //
    //This action is needed for checking is previous dialog finished
    //
    if (action.call.state == "deleted") {
      return _objectSpread({}, conv);
    }
    if (!conv.videoCall && action.call.state == "new") {
      return _objectSpread(_objectSpread({}, conv), {}, {
        videoCall: _objectSpread(_objectSpread({}, action.call), {}, {
          mic: false,
          local_connection: false
        })
      });
    }
    if (!conv.videoCall) return conv;
    return _objectSpread(_objectSpread({}, conv), {}, {
      videoCall: _objectSpread(_objectSpread({}, conv.videoCall), action.call)
    });
  }
  if (action.type === "PM_VIDEO_CALL_GET_LOCAL_STREAM_SUCCESS") {
    if (!conv.videoCall) return conv;
    return _objectSpread(_objectSpread({}, conv), {}, {
      videoCall: _objectSpread(_objectSpread({}, conv.videoCall), {}, {
        local_stream: action.stream,
        mic: true
      })
    });
  }
  if (action.type === "PM_VIDEO_CALL_REMOTE_STREAM") {
    if (!conv.videoCall) return conv;
    return _objectSpread(_objectSpread({}, conv), {}, {
      videoCall: _objectSpread(_objectSpread({}, conv.videoCall), {}, {
        remote_stream: action.stream
      })
    });
  }
  if (action.type === "PM_ACTION_VIDEO_CALL_TOGGLE_MIC") {
    if (!conv.videoCall) return conv;
    return _objectSpread(_objectSpread({}, conv), {}, {
      videoCall: _objectSpread(_objectSpread({}, conv.videoCall), {}, {
        mic: action.on
      })
    });
  }
  if (action.type === _pm2.PM_OPEN_ATTACHMENT) {
    return _objectSpread(_objectSpread({}, conv), {}, {
      view: _objectSpread(_objectSpread({}, conv.view), {}, {
        active_attachment: action.attachment
      })
    });
  }
  if (action.type === _pm2.PM_CLOSE_ATTACHMENT) {
    return _objectSpread(_objectSpread({}, conv), {}, {
      view: _objectSpread(_objectSpread({}, conv.view), {}, {
        active_attachment: false
      })
    });
  }
  if (action.type === _pm2.PM_MESSAGE) {
    // console.log("msg_msg", action);
    var msg_msg = messageFromRec(action.message);
    if (msg_msg.sender_uid == action.conversation_uid) {
      return markAsUnread(addMessagesToSession(conv, [action.message]));
    } else {
      return addMessagesToSession(conv, [action.message]);
    }
  }
  if (action.type === _pm2.PM_ACTION_LOAD_MESSAGES_SUCCESS) {
    var newConv = conv;
    if (conv.history.can_move_backward != action.history.can_move_backward) {
      newConv = _objectSpread(_objectSpread({}, conv), {}, {
        history: _objectSpread(_objectSpread({}, conv.history), {}, {
          can_move_backward: action.history.can_move_backward
        })
      });
    }
    return addMessagesToSession(newConv, action.history.messages);
  }
  if (action.type === _pm2.PM_SESSION_DECLINED) {
    if (conv.outgoing) {
      return _objectSpread(_objectSpread({}, conv), {}, {
        access: "PM_ACCESS_DENY",
        generalStatus: "denied_by_recipient",
        active: false,
        blocked: true
      });
    } else {
      return _objectSpread(_objectSpread({}, conv), {}, {
        access: "PM_ACCESS_DENY",
        generalStatus: "denied_by_me",
        active: false,
        blocked: true,
        view: {
          hidden: true,
          maximized: false,
          active_attachment: false
        }
      });
    }
  }
  return conv;
}
function rebuildCounters(conversations) {
  var counters = {
    total: 0,
    allowed: 0,
    requested_by_recipient: 0,
    requested_by_me: 0,
    denied_by_me: 0,
    denied_by_recipient: 0,
    cancelled: 0,
    allowed_unread: 0,
    blocked_by_me: 0,
    blocked_by_recipient: 0
  };
  for (var uid in conversations) {
    var conv = conversations[uid];
    counters.total++;
    if (conv.generalStatus == 'allowed') {
      counters.allowed++;
      if (conv.unread) {
        counters.allowed_unread++;
      }
    } else {
      if (!counters[conv.generalStatus]) counters[conv.generalStatus] = 0;
      counters[conv.generalStatus]++;
    }
  }
  return counters;
}
var initialState = {
  conversations: {},
  status: "disconnected",
  counters: {
    total: 0,
    allowed_unread: 0,
    allowed: 0,
    requested_by_recipient: 0,
    requested_by_me: 0,
    denied_by_recipient: 0,
    denied_by_me: 0,
    cancelled: 0,
    blocked_by_me: 0,
    blocked_by_recipient: 0
  }
};
function pm() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var status = undefined;
  if (action.type == "PM_CHANGE_CONNECTION_STATUS") {
    if (action.status == "disconnected") {
      return initialState;
    } else {
      return _objectSpread(_objectSpread({}, state), {}, {
        status: action.status
      });
    }
  }
  if (action.type === "PM_MY_USER_UPDATE") {
    var newUser = action.user;
    var newState = _objectSpread(_objectSpread({}, state), {}, {
      conversations: {}
    });
    for (var i in state.conversations) {
      var oldConversation = state.conversations[i];
      var _newConversation = _objectSpread(_objectSpread({}, oldConversation), {}, {
        users: _objectSpread(_objectSpread({}, oldConversation.users), {}, {
          me: action.user
        })
      });
      var newConv = updateConversation(oldConversation, _newConversation);
      if (newConv != "delete") newState.conversations[i] = newConv;
    }
    return newState;
  }
  var newConversations = pmConversations(state.conversations, action);
  var newCounters = state.counters;
  if (newConversations != state.conversations) {
    newCounters = rebuildCounters(newConversations);
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    conversations: newConversations,
    counters: newCounters
  });
}
function pmConversations() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var initialState = state;
  var updateStateConversation = updateStateConversationCurried(state);
  if ("conversation_uid" in action) {
    var conv = state[action.conversation_uid];
    if (conv) {
      var newConv = pmConversationReducer(conv, action);
      if (newConv == "delete") {
        var newState = _objectSpread({}, state);
        delete newState[action.conversation_uid];
        state = newState;
      } else if (newConv != conv) {
        var _newState = _objectSpread({}, state);
        _newState[action.conversation_uid] = newConv;
        state = _newState;
      }
    } else if ("data" in action && "conversation" in action.data) {
      var _newState2 = _objectSpread({}, state);
      _newState2[action.conversation_uid] = newConversation(action.data.conversation);
      state = _newState2;
    }
  }
  if (action.type === _pm2.PM_CONVERSATIONS) {
    var _pmConversations = {};
    for (var conv_id in action.data.conversations) {
      var _conv = action.data.conversations[conv_id];
      _pmConversations[_conv.users.recipient.uid] = newConversation(_conv);
    }
    var activeConversations = [];
    var allConversations = [];
    var hasAny = false;
    var hasAll = false;
    for (var uid in _pmConversations) {
      hasAny = true;
      if (!_pmConversations[uid].view.hidden) {
        // add to active
        activeConversations.push(_pmConversations[uid]);
      } else if (!_pmConversations[uid].blocked) {
        // add to all
        allConversations.push(_pmConversations[uid]);
        hasAll = true;
      }
    }
    allConversations.sort(function (pmConversation1, pmConversation2) {
      return pmConversation1.modified > pmConversation2.modified ? 1 : -1;
    });
    // start with at least 5 last conversations, to avoid lonely 'All' link,
    // which looks awkward

    while (activeConversations.length < 5 && allConversations.length > 0) {
      activeConversations.push(allConversations.pop());
    }
    for (var id in activeConversations) {
      var _uid = activeConversations[id].user.uid;
      _pmConversations[_uid].view.hidden = false;
    }
    return _pmConversations;
  }
  if (action.type === _pm2.PM_WINDOW_MINIMIZE || action.type === _pm2.PM_WINDOW_MAXIMIZE) {
    var _newState3 = minimizeAll(state);
    var maximized = action.type === _pm2.PM_WINDOW_MAXIMIZE;
    if (_newState3[action.conversation_uid]) {
      var conversation = _newState3[action.conversation_uid];
      if (maximized) {
        conversation = markAsRead(conversation);
        conversation.view.hidden = false;
      }
      var unread = action.type === _pm2.PM_WINDOW_MINIMIZE ? false : conversation.unread;
      var unreadCount = maximized ? 0 : state[action.conversation_uid].unreadCount;
      return _objectSpread(_objectSpread({}, _newState3), {}, _defineProperty({}, action.conversation_uid, _objectSpread(_objectSpread({}, conversation), {}, {
        unread: unread,
        unreadCount: unreadCount,
        view: _objectSpread(_objectSpread({}, conversation.view), {}, {
          maximized: maximized
        }),
        minimizedTimestamp: maximized ? state[action.conversation_uid].minimizedTimestamp : Math.round(Date.now() / 1000)
      })));
    }
  }
  if (action.type === _pm2.PM_WINDOW_MINIMIZE_ALL) {
    var _newState4 = {};
    for (var index in state) {
      _newState4[index] = _objectSpread(_objectSpread({}, state[index]), {}, {
        unread: false
      });
    }
    return minimizeAll(_newState4);
  }
  return state;
}